<div class="modal-content-wrapper">
  <div [class.loading-content]="loading">
    <h3 class="title">{{ title }}</h3>
    <div class="scrollable">
      <div class="task-status mb-3" *ngIf="status">
        {{ status }}
      </div>
      <div class="mb-3" *ngIf="complianceInfo && complianceInfo.length">
        <h5>Compliance Info:</h5>
        <ul class="compliance-info">
          <li *ngFor="let info of complianceInfo">
            {{ info }}
          </li>
        </ul>
      </div>
      <div class="mb-3" *ngIf="instructions">
        <h5>Instructions:</h5>
        <div class="ms-2">{{ instructions }}</div>
      </div>
      <div class="mb-3" *ngIf="rejectReason">
        <h5>Reject Reason:</h5>
        <div class="ms-2">{{ rejectReason }}</div>
      </div>
      <div class="uploaded-files">
        <div class="row">
          <div class="col-6 col-sm-4" *ngIf="allowNewFiles">
            <div class="document-item" (click)="uploadFile()">
              <div class="thumbnail">
                <div class="placeholder">
                  <i class="uil uil-export"></i>
                  <div>{{ placeholderMessage }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6 col-sm-4" *ngFor="let item of items; let i = index">
            <div class="document-item">
              <div class="thumbnail" (click)="uploadFile(i)">
                <div class="placeholder" *ngIf="!item.data; else itemContent">
                  <i class="uil uil-export"></i>
                  <div>{{ placeholderMessage }}</div>
                </div>
                <ng-template #itemContent>
                  <img
                    class="item-image"
                    [src]="item.data"
                    *ngIf="
                      item.type === 'jpeg' ||
                      item.type === 'jpg' ||
                      item.type === 'png' ||
                      item.type === 'tif' ||
                      item.type === 'tiff'
                    "
                  />
                  <img
                    class="pdf-icon"
                    src="assets/images/pdf.svg"
                    *ngIf="item.type === 'pdf'"
                    alt="PDF icon"
                  />
                </ng-template>
              </div>
              <div class="item-info mt-1">
                <div class="flex-1 overflow-hidden" [title]="item.name">
                  <div class="filename">{{ item.name }}</div>
                  <div class="filesize">{{ utils.formatSize(item.size) }}</div>
                </div>
                <div class="item-actions">
                  <button
                    class="btn ms-2"
                    (click)="rotateImage(i)"
                    *ngIf="item.data && item.type !== 'pdf'"
                  >
                    <i class="mdi mdi-reload"></i>
                  </button>
                  <button
                    class="btn btn-danger"
                    (click)="removeFile(i)"
                    *ngIf="item.data"
                  >
                    <i class="mdi mdi-trash-can-outline"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="actions">
  <button
    class="btn btn-success me-2"
    (click)="submitForm()"
    [disabled]="!canSubmit"
  >
    Submit
  </button>
  <button class="btn btn-danger" (click)="dismiss.emit()">Cancel</button>
</div>
<div class="loading" *ngIf="loading">
  <app-ui-preloader [display]="true"></app-ui-preloader>
  <div class="loading-text">Processing Submission. Please wait...</div>
</div>
